import * as React from 'react';
import { SlideshowBlockContent, VideoBlockContent } from '../../../../commonv3/types/block';
import { BlockDescription } from '../../atoms/blocks/BlockDescription';
import Slider from 'react-slick';
import './slideshowBlockContentPane.scss';
import { BlockImage } from '../../atoms/blocks/BlockImage';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
    content: SlideshowBlockContent;
};

@observer
export class SlideshowBlockContentPane extends React.Component<Props> {
    render() {
        const { content } = this.props;
        return (
            <div>
                {GlobalStatesV3.viewport.isMobile && (
                    <Slider slidesToShow={1} slidesToScroll={1} arrows={true} dots={true}>
                        {content.imageRefs.map((imageRef) => (
                            <div>
                                <BlockImage key={imageRef} imageRef={imageRef} />
                            </div>
                        ))}
                    </Slider>
                )}
                <BlockDescription content={content.description} />
                {GlobalStatesV3.viewport.isDesktop && (
                    <Slider slidesToShow={1} slidesToScroll={1} arrows={true} dots={true}>
                        {content.imageRefs.map((imageRef) => (
                            <div>
                                <BlockImage key={imageRef} imageRef={imageRef} />
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
        );
    }
}
